import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface FormValues {
    url: string;
    user: string;
    password: string;
    clientId: string,
    clientSecret: string,
    tlsCertificate: string;
}

export const defaultValues: FormValues = {
    url: '',
    user: '',
    password: '',
    clientId: '',
    clientSecret: '',
    tlsCertificate: '',
};

function setSchema(endpointType: string) {
  return yup.object({
    url: yup
      .string()
      .concat(yup.string().required('URL is required.')
        .matches(/^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/\S*)?$/i, 'Please enter a valid URL (e.g https://eteamproject.internal.ericsson.com).')),
    user: yup
      .string()
      .concat(endpointType === 'EOLM' ? yup.string().required('User Name is required.')
        .min(1, 'User Name cannot be empty.') : yup.string()),
    password: yup
      .string()
      .concat(endpointType === 'EOLM' ? yup.string().required('Password is required.')
        .min(1, 'Password cannot be empty') : yup.string()),
    clientId: yup
      .string()
      .concat(endpointType !== 'EOLM' ? yup.string().required('Client ID is required.')
        .min(1, 'User Name cannot be empty.') : yup.string()),
    clientSecret: yup
      .string()
      .concat(endpointType !== 'EOLM' ? yup.string().required('Client Secret is required.')
        .min(1, 'Password cannot be empty') : yup.string()),
    tlsCertificate: yup.string().concat(yup.string().required('SFTP Path is required').min(1, 'SFTP Path cannot be empty'))
  });
}

export function useEndpointForm(endpointType: string, initialValues?: FormValues) {
  const schema = setSchema(endpointType)
  return useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
    defaultValues: { ...defaultValues, ...initialValues }
  });
}